import React, { FunctionComponent, useState } from "react";
import { Grid } from "@material-ui/core";
import { UserInformation } from "./user-information";
import { UserUpdatePassword } from "./user-update-password";

interface IUserDataContentProps {}

export const UserDataContent: FunctionComponent<IUserDataContentProps> = (props) => {
  const [showChangePassword, setShowChangePassword] = useState<boolean>(false);
  return (
    <Grid container>
      {!showChangePassword && <UserInformation onChangePassword={() => setShowChangePassword(true)} />}
      {showChangePassword && <UserUpdatePassword onReturn={() => setShowChangePassword(false)} />}
    </Grid>
  );
};
